import styled from "styled-components";

export const DietContainerStyled = styled.div``;
